module.exports = __webpack_public_path__ + "img/askmebet-support.d9930d82.png";